/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppLibraryRouteImport } from './routes/_app.library'
import { Route as AppIhubRouteImport } from './routes/_app.ihub'
import { Route as AppBookkeepingRouteImport } from './routes/_app.bookkeeping'
import { Route as AppAskmeRouteImport } from './routes/_app.askme'
import { Route as AppLibrarySongsRouteImport } from './routes/_app.library_.songs'
import { Route as AppLibrarySongWorkspaceRouteImport } from './routes/_app.library_.song-workspace'
import { Route as AppLibrarySongsJobIdRouteImport } from './routes/_app.library_.songs_.$jobId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppLibraryRoute = AppLibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => AppRoute,
} as any)
const AppIhubRoute = AppIhubRouteImport.update({
  id: '/ihub',
  path: '/ihub',
  getParentRoute: () => AppRoute,
} as any)
const AppBookkeepingRoute = AppBookkeepingRouteImport.update({
  id: '/bookkeeping',
  path: '/bookkeeping',
  getParentRoute: () => AppRoute,
} as any)
const AppAskmeRoute = AppAskmeRouteImport.update({
  id: '/askme',
  path: '/askme',
  getParentRoute: () => AppRoute,
} as any)
const AppLibrarySongsRoute = AppLibrarySongsRouteImport.update({
  id: '/library_/songs',
  path: '/library/songs',
  getParentRoute: () => AppRoute,
} as any)
const AppLibrarySongWorkspaceRoute = AppLibrarySongWorkspaceRouteImport.update({
  id: '/library_/song-workspace',
  path: '/library/song-workspace',
  getParentRoute: () => AppRoute,
} as any)
const AppLibrarySongsJobIdRoute = AppLibrarySongsJobIdRouteImport.update({
  id: '/library_/songs_/$jobId',
  path: '/library/songs/$jobId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/askme': typeof AppAskmeRoute
  '/bookkeeping': typeof AppBookkeepingRoute
  '/ihub': typeof AppIhubRoute
  '/library': typeof AppLibraryRoute
  '/settings': typeof AppSettingsRoute
  '/library/song-workspace': typeof AppLibrarySongWorkspaceRoute
  '/library/songs': typeof AppLibrarySongsRoute
  '/library/songs/$jobId': typeof AppLibrarySongsJobIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/askme': typeof AppAskmeRoute
  '/bookkeeping': typeof AppBookkeepingRoute
  '/ihub': typeof AppIhubRoute
  '/library': typeof AppLibraryRoute
  '/settings': typeof AppSettingsRoute
  '/library/song-workspace': typeof AppLibrarySongWorkspaceRoute
  '/library/songs': typeof AppLibrarySongsRoute
  '/library/songs/$jobId': typeof AppLibrarySongsJobIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_app/askme': typeof AppAskmeRoute
  '/_app/bookkeeping': typeof AppBookkeepingRoute
  '/_app/ihub': typeof AppIhubRoute
  '/_app/library': typeof AppLibraryRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/library_/song-workspace': typeof AppLibrarySongWorkspaceRoute
  '/_app/library_/songs': typeof AppLibrarySongsRoute
  '/_app/library_/songs_/$jobId': typeof AppLibrarySongsJobIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/askme'
    | '/bookkeeping'
    | '/ihub'
    | '/library'
    | '/settings'
    | '/library/song-workspace'
    | '/library/songs'
    | '/library/songs/$jobId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/askme'
    | '/bookkeeping'
    | '/ihub'
    | '/library'
    | '/settings'
    | '/library/song-workspace'
    | '/library/songs'
    | '/library/songs/$jobId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_app/askme'
    | '/_app/bookkeeping'
    | '/_app/ihub'
    | '/_app/library'
    | '/_app/settings'
    | '/_app/library_/song-workspace'
    | '/_app/library_/songs'
    | '/_app/library_/songs_/$jobId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/library': {
      id: '/_app/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof AppLibraryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ihub': {
      id: '/_app/ihub'
      path: '/ihub'
      fullPath: '/ihub'
      preLoaderRoute: typeof AppIhubRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bookkeeping': {
      id: '/_app/bookkeeping'
      path: '/bookkeeping'
      fullPath: '/bookkeeping'
      preLoaderRoute: typeof AppBookkeepingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/askme': {
      id: '/_app/askme'
      path: '/askme'
      fullPath: '/askme'
      preLoaderRoute: typeof AppAskmeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/library_/songs': {
      id: '/_app/library_/songs'
      path: '/library/songs'
      fullPath: '/library/songs'
      preLoaderRoute: typeof AppLibrarySongsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/library_/song-workspace': {
      id: '/_app/library_/song-workspace'
      path: '/library/song-workspace'
      fullPath: '/library/song-workspace'
      preLoaderRoute: typeof AppLibrarySongWorkspaceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/library_/songs_/$jobId': {
      id: '/_app/library_/songs_/$jobId'
      path: '/library/songs/$jobId'
      fullPath: '/library/songs/$jobId'
      preLoaderRoute: typeof AppLibrarySongsJobIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAskmeRoute: typeof AppAskmeRoute
  AppBookkeepingRoute: typeof AppBookkeepingRoute
  AppIhubRoute: typeof AppIhubRoute
  AppLibraryRoute: typeof AppLibraryRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppLibrarySongWorkspaceRoute: typeof AppLibrarySongWorkspaceRoute
  AppLibrarySongsRoute: typeof AppLibrarySongsRoute
  AppLibrarySongsJobIdRoute: typeof AppLibrarySongsJobIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAskmeRoute: AppAskmeRoute,
  AppBookkeepingRoute: AppBookkeepingRoute,
  AppIhubRoute: AppIhubRoute,
  AppLibraryRoute: AppLibraryRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppLibrarySongWorkspaceRoute: AppLibrarySongWorkspaceRoute,
  AppLibrarySongsRoute: AppLibrarySongsRoute,
  AppLibrarySongsJobIdRoute: AppLibrarySongsJobIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
